module.exports = __webpack_public_path__ + "static/webhook-dc354c3b31f89e71f37225be8d192737.png";